import React from 'react';
import DataTableCard from 'components/DataTableCard';
import strftime from 'strftime';



type ExerciseSessionCountsProps = {
    partner : string | string[]
    start? : Date
    end? : Date
}

function ExerciseSessionCounts(props:ExerciseSessionCountsProps) {

    const startDate = props.start ? strftime("%Y-%m-%d", props.start) : ""
    const endDate = props.end ? strftime("%Y-%m-%d", props.end) : ""


    return (
        <DataTableCard url="exercise-session-counts/" 
            partner={props.partner} 
            aux_url_params={ {start:startDate, end:endDate} }
            title="Exercise Session Counts" 
            subtitle="counts number of performed sessions that include each exercise" 
        />
    )
}

export default ExerciseSessionCounts;
